import {
  ArrowLeft,
  BookOpen,
  FileText,
  ChevronRight,
  Search,
} from "lucide-react";
import Footer from "../../../ui/Footer/Footer";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import {
  getCategoryBySlug,
  categories as allCategories,
} from "./helpCenterData";
import styles from "../HelpCenter.module.css";
import catStyles from "./HelpCategoryPage.module.css";

const HelpCategoryPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const category = getCategoryBySlug(slug || "");

  if (!category) {
    return (
      <div className={styles.container}>
        <div className={styles.hero}>
          <div className={styles.heroInner}>
            <div className={styles.heroNav}>
              <Link to="/HelpCenter" className={styles.backLink}>
                <ArrowLeft size={16} /> Back to Help Center
              </Link>
            </div>
            <h1 className={styles.heroTitle}>Category Not Found</h1>
          </div>
        </div>
      </div>
    );
  }

  const filtered = search
    ? category.articles.filter((a) =>
        a.title.toLowerCase().includes(search.toLowerCase()),
      )
    : category.articles;

  return (
    <div className={styles.container}>
      <div className={styles.hero}>
        <div className={styles.heroInner}>
          <div className={styles.heroNav}>
            <Link to="/HelpCenter" className={styles.backLink}>
              <ArrowLeft size={16} /> Back to Help Center
            </Link>
          </div>
          <h1 className={styles.heroTitle}>{category.title}</h1>
          <p className={styles.heroSubtitle}>{category.desc}</p>
          <div className={styles.searchBox}>
            <Search size={18} className={styles.searchIcon} />
            <input
              type="text"
              placeholder={`Search in ${category.title}...`}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className={styles.tabBar}>
        <Link to="/contact" className={styles.tab}>
          Contact Us
        </Link>
        <Link to="/HelpCenter" className={`${styles.tab} ${styles.tabActive}`}>
          Help Center
        </Link>
        {/* <Link to="/issues" className={styles.tab}>
          Report an Issue
        </Link> */}
      </div>

      <div className={styles.mainContent}>
        {/* Breadcrumb */}
        <div className={catStyles.breadcrumb}>
          <Link to="/HelpCenter">Help Center</Link>
          <ChevronRight size={14} />
          <span>{category.title}</span>
        </div>

        <div className={catStyles.layout}>
          {/* Sidebar - other categories */}
          <aside className={catStyles.sidebar}>
            <h3 className={catStyles.sidebarTitle}>
              <BookOpen size={16} /> Categories
            </h3>
            {allCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/HelpCenter/category/${cat.slug}`}
                className={`${catStyles.sidebarLink} ${cat.slug === slug ? catStyles.sidebarLinkActive : ""}`}
              >
                {cat.title}
                <span className={catStyles.sidebarCount}>
                  {cat.articles.length}
                </span>
              </Link>
            ))}
          </aside>

          {/* Articles list */}
          <div className={catStyles.content}>
            <h2 className={catStyles.contentTitle}>
              {filtered.length} {filtered.length === 1 ? "article" : "articles"}
              {search && ` matching "${search}"`}
            </h2>
            <div className={styles.articlesList}>
              {filtered.map((article) => (
                <div
                  key={article.id}
                  className={styles.articleItem}
                  onClick={() => navigate(`/HelpCenter/article/${article.id}`)}
                >
                  <div className={styles.articleInfo}>
                    <div className={styles.articleIcon}>
                      <FileText size={14} />
                    </div>
                    <div className={styles.articleText}>
                      <h4>{article.title}</h4>
                      <span>
                        {article.readTime} read · Updated {article.lastUpdated}
                      </span>
                    </div>
                  </div>
                  <div className={styles.articleMeta}>
                    {article.badge === "new" && (
                      <span className={`${styles.badge} ${styles.badgeNew}`}>
                        New
                      </span>
                    )}
                    {article.badge === "popular" && (
                      <span
                        className={`${styles.badge} ${styles.badgePopular}`}
                      >
                        Popular
                      </span>
                    )}
                    {article.badge === "updated" && (
                      <span
                        className={`${styles.badge} ${styles.badgeUpdated}`}
                      >
                        Updated
                      </span>
                    )}
                    <ChevronRight size={16} className={styles.articleArrow} />
                  </div>
                </div>
              ))}
              {filtered.length === 0 && (
                <div className={catStyles.noResults}>
                  No articles found matching your search.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default HelpCategoryPage;
